module.exports = __webpack_public_path__ + "static/media/preplay-up-arrow-black.86e9a30f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preplay-up-arrow-black.svg
// module id = ./src/assets/images/preplay-up-arrow-black.svg
// module chunks = 6